// Lib
import chroma from 'chroma-js';
import { Thunk } from '../../../../../types/reduxTypes';

// Actions
import { getNewElementId } from '../../../../../element/actions/elementActions';
import { addRootToTag, createTag } from '../../../../../../common/tags/tagActions';

// Types
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import { Tag, TagCreationData } from '../../../../../../common/tags/tagTypes';
import { getCurrentContextRootId } from './tagUtils';
import { addTagToElements } from '../../../../../element/tags/elementTagActions';

const createNewTagThunk =
    (tagData: TagCreationData): Thunk<Tag> =>
    (dispatch: Function) => {
        const id = dispatch(getNewElementId());

        const { name, creator, rootBoardIds, color } = tagData;
        const tag = {
            id,
            name,
            rootBoardIds,
            color: color || chroma.random().hex(),
            meta: {
                creator,
                createdTime: Date.now(),
                modifiedTime: Date.now(),
            },
        };

        dispatch(createTag(tag));
        return tag;
    };

export const addTagToElementsThunk =
    (tag: Tag, elements: Immutable.List<ImMNElement>, currentBoardId: string, shareRootPath: ImMNElement[]): Thunk =>
    (dispatch: Function) => {
        if (!getCurrentContextRootId(tag, shareRootPath)) {
            dispatch(addRootToTag(tag, currentBoardId));
        }

        dispatch(addTagToElements(elements, tag.id));
    };

export const createAndAddTagToElementsThunk =
    (
        tagData: TagCreationData,
        elements: Immutable.List<ImMNElement>,
        currentBoardId: string,
        shareRootPath: ImMNElement[],
    ): Thunk =>
    (dispatch: Function) => {
        const newTag = dispatch(createNewTagThunk(tagData));
        dispatch(addTagToElementsThunk(newTag, elements, currentBoardId, shareRootPath));
    };
